<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="share-icon"
    :width="size"
    :height="size"
    viewBox="0 0 19 20"
    fill="none">
    <path
      d="M15.9118 14.1365C15.1488 14.1365 14.466 14.4378 13.9439 14.9096L6.7853 10.743C6.8355 10.512 6.87566 10.2811 6.87566 10.0402C6.87566 9.7992 6.8355 9.56827 6.7853 9.33735L13.8636 5.21084C14.4058 5.71285 15.1186 6.0241 15.9118 6.0241C17.5785 6.0241 18.9239 4.67871 18.9239 3.01205C18.9239 1.34538 17.5785 0 15.9118 0C14.2451 0 12.8998 1.34538 12.8998 3.01205C12.8998 3.25301 12.9399 3.48394 12.9901 3.71486L5.9118 7.84137C5.36963 7.33936 4.65678 7.02811 3.86361 7.02811C2.19694 7.02811 0.851562 8.37349 0.851562 10.0402C0.851562 11.7068 2.19694 13.0522 3.86361 13.0522C4.65678 13.0522 5.36963 12.741 5.9118 12.239L13.0604 16.4157C13.0102 16.6265 12.9801 16.8474 12.9801 17.0683C12.9801 18.6847 14.2953 20 15.9118 20C17.5283 20 18.8435 18.6847 18.8435 17.0683C18.8435 15.4518 17.5283 14.1365 15.9118 14.1365Z"
      :fill="color" />
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: String,
      default: '20px',
    },
    color: {
      type: String,
      default: 'var(--bs-primary)',
    },
  });
</script>

<style lang="css">
  .share-icon__path {
    fill: var(--bs-primary);
  }
</style>
